import React from 'react';

export const C = {
  green:'#16A085', greenBg:'#E8F8F5',
  red:'#C0392B',   redBg:'#FDECEA',
  blue:'#2980B9',  blueBg:'#EBF5FB',
  amber:'#B7791F', amberBg:'#FEFCE8',
  purple:'#6B46C1',purpleBg:'#F0E9F8',
  text:'#1E293B',  soft:'#64748B',
  border:'#E2E8F0', card:'#FFFFFF',
};

export const brl = v =>
  (parseFloat(v)||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});

export const fmtDate = s => {
  if (!s) return '—';
  const d = new Date(s);
  return d.toLocaleDateString('pt-BR');
};

export const STATUS_MAP = {
  pending: { label:'Pendente', bg:C.amberBg, color:C.amber },
  paid:    { label:'Pago',     bg:C.greenBg, color:C.green },
  overdue: { label:'Vencido',  bg:C.redBg,   color:C.red   },
  canceled:{ label:'Cancelado',bg:'#EDF2F7', color:'#718096'},
};

export function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || STATUS_MAP.pending;
  return (
    <span style={{display:'inline-flex',alignItems:'center',gap:4,padding:'2px 10px',
      borderRadius:20,fontSize:11,fontWeight:700,background:s.bg,color:s.color}}>
      <span style={{width:6,height:6,borderRadius:'50%',background:s.color,display:'inline-block'}}/>
      {s.label}
    </span>
  );
}

export function KPICard({ icon, label, value, valueColor, sub, iconBg, iconColor }) {
  return (
    <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,
      padding:'16px 20px',flex:1,minWidth:180}}>
      <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:10}}>
        <div style={{width:36,height:36,borderRadius:8,background:iconBg,flexShrink:0,
          display:'flex',alignItems:'center',justifyContent:'center'}}>
          <i className={`fas fa-${icon}`} style={{color:iconColor,fontSize:14}}/>
        </div>
        <span style={{fontSize:11,fontWeight:700,textTransform:'uppercase',
          letterSpacing:'0.06em',color:C.soft}}>{label}</span>
      </div>
      <div style={{fontSize:22,fontWeight:800,color:valueColor||C.text,lineHeight:1.2}}>{value}</div>
      {sub && <div style={{fontSize:11.5,color:C.soft,marginTop:4}}>{sub}</div>}
    </div>
  );
}

export function Overlay({ show, onClose, title, width, children, footer }) {
  if (!show) return null;
  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',
      zIndex:1050,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
      <div onClick={e=>e.stopPropagation()} style={{background:C.card,borderRadius:14,
        width:'100%',maxWidth:width||900,maxHeight:'90vh',overflow:'hidden',
        display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
        <div style={{padding:'16px 24px',borderBottom:`1px solid ${C.border}`,
          display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
          <h3 style={{margin:0,fontSize:16,fontWeight:700,color:C.text}}>{title}</h3>
          <button onClick={onClose} style={{background:'none',border:'none',cursor:'pointer',
            width:32,height:32,borderRadius:'50%',display:'flex',alignItems:'center',
            justifyContent:'center',color:C.soft,fontSize:18}}>×</button>
        </div>
        <div style={{overflowY:'auto',flex:1,padding:24}}>{children}</div>
        {footer && (
          <div style={{padding:'12px 24px',borderTop:`1px solid ${C.border}`,
            background:'#F8FAFC',display:'flex',justifyContent:'flex-end',gap:10,flexShrink:0}}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

export function Btn({ onClick, color, outline, disabled, children, small }) {
  const bg = outline ? C.card : (color || C.blue);
  const cl = outline ? (color || C.blue) : '#fff';
  return (
    <button onClick={onClick} disabled={disabled} style={{
      background:bg, color:cl, border:`1px solid ${outline?(color||C.blue):bg}`,
      borderRadius:8, padding: small ? '5px 12px' : '8px 16px',
      fontSize: small ? 12 : 13, fontWeight:600, cursor:disabled?'not-allowed':'pointer',
      opacity:disabled?0.6:1, display:'inline-flex', alignItems:'center', gap:6,
    }}>{children}</button>
  );
}

export function Field({ label, required, children }) {
  return (
    <div style={{marginBottom:12}}>
      <label style={{display:'block',fontSize:11.5,fontWeight:600,color:C.soft,marginBottom:4}}>
        {label}{required && <span style={{color:C.red}}>*</span>}
      </label>
      {children}
    </div>
  );
}

export function Input({ value, onChange, name, type='text', placeholder, disabled }) {
  return (
    <input type={type} value={value||''} onChange={onChange} name={name}
      placeholder={placeholder} disabled={disabled}
      style={{width:'100%',padding:'7px 10px',border:`1px solid ${C.border}`,
        borderRadius:7,fontSize:13,color:C.text,background:disabled?'#F8FAFC':'#fff',
        outline:'none',boxSizing:'border-box'}}/>
  );
}

export function Select({ value, onChange, name, children, disabled }) {
  return (
    <select value={value||''} onChange={onChange} name={name} disabled={disabled}
      style={{width:'100%',padding:'7px 10px',border:`1px solid ${C.border}`,
        borderRadius:7,fontSize:13,color:C.text,background:disabled?'#F8FAFC':'#fff',
        outline:'none',boxSizing:'border-box'}}>
      {children}
    </select>
  );
}

export const PAYMENT_METHODS = ['PIX','Boleto','Cartão de Débito','Cartão de Crédito',
  'Transferência (TED/DOC)','Dinheiro','Cheque'];

export function periodRange(period) {
  const t = new Date();
  const y = t.getFullYear(), m = t.getMonth();
  if (period === 'month') {
    return {
      start_date: new Date(y,m,1).toISOString().split('T')[0],
      end_date:   new Date(y,m+1,0).toISOString().split('T')[0],
    };
  }
  if (period === 'last_month') {
    return {
      start_date: new Date(y,m-1,1).toISOString().split('T')[0],
      end_date:   new Date(y,m,0).toISOString().split('T')[0],
    };
  }
  if (period === 'next30') {
    return {
      start_date: t.toISOString().split('T')[0],
      end_date:   new Date(y,m,t.getDate()+30).toISOString().split('T')[0],
    };
  }
  return {}; // todos
}

/**
 * Converte lista plana de accounts (com parent_id) numa lista com profundidade,
 * mantendo a hierarquia de exibição.
 */
function buildAccountTree(accounts) {
  const map = {};
  accounts.forEach(a => { map[a.id] = { ...a, children: [] }; });
  const roots = [];
  accounts.forEach(a => {
    if (a.parent_id && map[a.parent_id]) {
      map[a.parent_id].children.push(map[a.id]);
    } else {
      roots.push(map[a.id]);
    }
  });
  const flat = [];
  function walk(node, depth) {
    flat.push({ id: node.id, name: node.name, depth, hasChildren: node.children.length > 0 });
    node.children.forEach(c => walk(c, depth + 1));
  }
  roots.forEach(r => walk(r, 0));
  return flat;
}

/** Select com hierarquia visual via indentação e optgroup separado por nós raiz. */
export function AccountSelect({ value, onChange, name, accounts, placeholder, disabled }) {
  const tree = buildAccountTree(accounts || []);

  const selStyle = {
    width: '100%', padding: '7px 10px', border: `1px solid ${C.border}`,
    borderRadius: 7, fontSize: 13, color: C.text,
    background: disabled ? '#F8FAFC' : '#fff', outline: 'none', boxSizing: 'border-box',
  };

  return (
    <select value={value || ''} onChange={onChange} name={name} disabled={disabled} style={selStyle}>
      <option value="">{placeholder || '— Selecione —'}</option>
      {tree.map(node => {
        // Nós que têm filhos são "grupos" — exibidos como separadores desabilitados
        if (node.hasChildren) {
          const pad = '\u00a0\u00a0\u00a0'.repeat(node.depth);
          return (
            <option key={node.id} value={node.id} disabled
              style={{ fontWeight: 700, color: '#374151', background: '#F3F4F6' }}>
              {pad}{node.name}
            </option>
          );
        }
        const pad = '\u00a0\u00a0\u00a0\u00a0\u00a0'.repeat(node.depth);
        return (
          <option key={node.id} value={node.id} style={{ color: C.text }}>
            {pad}{'└ '}{node.name}
          </option>
        );
      })}
    </select>
  );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/components/shared.jsx